// extracted by mini-css-extract-plugin
export default {"reactPlayer":"Template5_reactPlayer__fRTkH","heading":"Template5_heading__4xqNo","tagline":"Template5_tagline__LQfKb"};